<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des types des dossiers</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="6">
              <SlickList  lockAxis="y" v-model="allTypes" class="list-group" :useDragHandle="true" @sort-end="">
                <item-list v-for="(type, index) in allTypes" :index="index" :key="index" :item="type" :selectedItemId="typeId">{{ type.libelle }} <span class="smaller-2 ml-2">(groupe : {{ type.groupe.toUpperCase() }})</span><i v-if="canManageType()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteType(type.id)"></i><i v-if="canManageType()" class="icon fa fa-pencil float-right clickable" @click="edit(type)"></i></item-list>
              </SlickList>
            </b-col>
            <b-col md="6">
              <b-card :header-bg-variant="action === 'create' ? 'primary' : 'warning' ">
                <template v-slot:header >
                   <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </template>
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label='Libellé'
                      label-for='libelle'
                    >
                      <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.libelle }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Libellé technique'
                      label-for='libelleTechnique'
                    >
                      <b-form-input id='libelleTechnique' type='text' v-model="libelleTechnique" :class="{hasError: errors.libelleTechnique !== ''}" :disabled="action !== 'create'"></b-form-input>
                      <span class='field-error'>{{ errors.libelleTechnique }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Libellé court'
                      label-for='libelleCourt'
                    >
                      <b-form-input id='libelleCourt' type='text' v-model="libelleCourt" :class="{hasError: errors.libelleCourt !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.libelleCourt }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Code'
                      label-for='code'
                    >
                      <b-form-input id='code' type='text' v-model="code" :class="{hasError: errors.code !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.code }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Groupe'
                      label-for='groupe'
                    >
                      <b-form-input id='groupe' type='text' v-model="groupe" :class="{hasError: errors.groupe !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.groupe }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Créer</b-button>
                    <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Modifier</b-button>
                    <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-2 mt-1 pull-right">
                      <i class="fa fa-eraser"></i> Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import itemList from '@/components/SortListItem'
import {isEmpty} from "@/utils/fileHelper";

export default {
  components: {
    SlickList,
    itemList
  },
  data() {
    return {
      typeId: 0,
      allTypes: [],
      libelle: '',
      libelleTechnique: '',
      libelleCourt: '',
      groupe: '',
      code: '',
      action: 'create',
      libelleFormCardTitle: 'Création d\'un type pour les dossiers',
      errors: {
        libelle: '',
        libelleTechnique: '',
        libelleCourt: '',
        code: '',
        groupe: '',
      }
    }
  },
  watch: {
    allTypes: function(newVal, oldVal) {
      console.log(newVal, oldVal)
      if (this.canManageType()) {
        if (!isEmpty(oldVal)) {
          this.sorted()
        }
      }
    },
  },
  mounted() {
    this.getTypes()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getTypes() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/espaceGestion/dossier/getAllType")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          this.allTypes = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    sorted() {
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'types': this.allTypes
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/espaceGestion/parametrage/type/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors du tri, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    create() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'libelle_court': this.libelleCourt,
          'groupe': this.groupe,
          'code': this.code,
          'ordre': 99,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/parametrage/type/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getTypes()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création du type, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'libelle_court': this.libelleCourt,
          'groupe': this.groupe,
          'code': this.code,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/parametrage/type/modify/'+this.typeId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getTypes()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du type, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteType(typeId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer ce type ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/espaceGestion/parametrage/type/delete/"+typeId).then(response => {
                this.$store.commit("IS_LOADING", false)
                this.getTypes()
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false);
                  let errorText = "Une erreur est survenue, lors de la suppression du type. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  if (error.response.status === 406) { errorText =  error.response.data.message}
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    canManageType() {
      return hasRule(rules.CAN_CONFIGURE_DOSSIER)
    },
    edit(type) {
      this.libelle = type.libelle
      this.libelleTechnique = type.libelle_technique
      this.libelleCourt = type.libelle_court
      this.groupe = type.groupe
      this.code = type.code
      this.typeId = type.id
      this.action = 'modify'
      this.libelleFormCardTitle = 'Modification du type : ' + type.libelle
    },
    validate() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      if (this.libelleTechnique === '') {
        this.errors.libelleTechnique = 'Le libelle technique est obligatoire'
        valid = false;
      }

      if (this.libelleCourt === '') {
        this.errors.libelleCourt = 'Le libelle court est obligatoire'
        valid = false;
      }

      if (this.groupe === '') {
        this.errors.groupe = 'Le groupe est obligatoire'
        valid = false;
      }

      if (this.code === '') {
        this.errors.code = 'Le code est obligatoire'
        valid = false;
      }

      return valid
    },
    clearForm() {
      this.clearError()
      this.libelle = ''
      this.libelleTechnique = ''
      this.libelleCourt = ''
      this.groupe = ''
      this.code = ''
      this.typeId = 0
      this.action = 'create'
      this.libelleFormCardTitle = 'Création d\'un type pour les dossiers'
    },
    clearError() {
      this.errors.libelle = ''
      this.errors.libelleTechnique = ''
      this.errors.libelleCourt = ''
      this.errors.groupe = ''
      this.errors.code = ''
    },
  }
}
</script>
